
const ModelFormItem = ({inputName,inputType }) => {

    return(
       
                        
        <div className="form-group cassandra-form-group">
            <label>{inputName}</label>
            <input  className="form-control cassandra-form-control" type={inputType} placeholder={inputName}/>
        </div>

                           
            
    );

};
export default ModelFormItem;
